import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import useAcvDatadog from '@/composables/useAcvDatadog';
import { eventNames } from '@/constants/mixpanelEventNames';

export { eventNames };

export function useAcvAnalytics() {
  const { $mixpanel } = useNuxtApp();
  const userDetailsStore = useUserDetailsStore();
  const { carrierID, userID } = storeToRefs(userDetailsStore);
  const { addRumAction } = useAcvDatadog();

  function _buildProperties(properties) {
    return {
      carrier_id: carrierID.value,
      user_id: userID.value,
      distinct_id: userID.value,
      ...properties,
    };
  }

  function trackEvent(event, properties) {
    const eventProperties = _buildProperties(properties);
    $mixpanel?.track(event, eventProperties);
    addRumAction(event, eventProperties);
  }

  function trackMixPanel(event, properties) {
    $mixpanel?.track(event, _buildProperties(properties));
  }

  return { trackEvent, trackMixPanel, eventNames };
}
